import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
import {
  Button,
  Card,
  Col,
  ContentBody,
  ContentHeader,
  DatePicker,
  Row,
  ListItem,
  Select
} from '../../../core/components'
import { Select as AntdSelect, Tabs } from 'antd'
import { dateTimeFormat } from '../../../utils/format/dateTimeFormat'
import useOpportunity from '../../../services/queries/opportunity/useOpportunity'
import { dateFormat } from '../../../utils/format/dateFormat'
import Modal from 'antd/lib/modal/Modal'
import { useEffect, useState } from 'react'
import useOpportunityUpdate from '../../../services/mutations/useOpportunityUpdate'
import useOpportunityConcepts from '../../../services/queries/opportunity/useOpportunityConcepts'

const { TabPane } = Tabs
const { Option } = AntdSelect

export const DetailOpportunityPage = () => {
  const { goBack } = useHistory()
  const { id }: any = useParams()
  const { data: opportunity, error, isLoading }: any = useOpportunity(id)
  const [nextContact, setNextContact] = useState<any>('')
  const [conceptId, setConceptId] = useState<string>('')

  const [isContactModalVisible, setIsContactModalVisible] =
    useState<boolean>(false)
  const { data: concepts, isLoading: isConceptsLoading } =
    useOpportunityConcepts({
      page: 1,
      limit: 999
    })

  useEffect(() => {
    setConceptId(opportunity?.data?.concept.id || '')
  }, [opportunity])

  const { mutate } = useOpportunityUpdate()

  const showContactModal = () => {
    setIsContactModalVisible(true)
  }

  const handleContactOk = async () => {
    const {
      event,
      campaign,
      status,
      proposalValidity,
      salesForecast,
      customer,
      situation,
      contacter,
      seller,
      market,
      businessUnity
    } = opportunity.data

    mutate({
      ...opportunity.data,
      nextContact,
      id,
      conceptId,
      businessUnityId: businessUnity?.id,
      eventId: event?.id,
      // campaignId: campaign?.id,
      statusId: status?.id,
      customerId: customer?.id,
      situationId: situation?.id,
      contacterId: contacter?.id,
      seller: seller?.id,
      market: market?.id,
      salesForecast: dateFormat(salesForecast),
      proposalValidity: dateFormat(proposalValidity)
    })
    setIsContactModalVisible(false)
  }

  const handleContactCancel = () => {
    setIsContactModalVisible(false)
  }

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  function onOk(value: any) {
    setNextContact(value)
  }

  return (
    <div>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Detalhes da Oportunidade
      </ContentHeader>
      <ContentBody>
        <Tabs type="line">
          <TabPane tab="Geral" key="1">
            <Button
              type="primary"
              icon={<EditOutlined />}
              style={{
                marginBottom: 30
              }}
              onClick={showContactModal}
            >
              Editar
            </Button>
            <Card>
              <div style={{ fontSize: '16px' }}>
                <Row>
                  <Col span={12}>
                    <ListItem label="UNIDADE DE NEGÓCIO">
                      {opportunity?.data.businessUnity.id}
                    </ListItem>
                    <ListItem label="CLIENTE">
                      {opportunity?.data.customer.name}
                    </ListItem>
                    <ListItem label="VENDEDOR">
                      {opportunity?.data.seller.name}
                    </ListItem>
                    <ListItem label="MERCADO">
                      {opportunity?.data.market.name}
                    </ListItem>
                    <ListItem label="NR PEDIDO">
                      {opportunity?.data.orderId}
                    </ListItem>
                  </Col>
                  <Col span={12}>
                    <ListItem label="SITUAÇÃO">
                      {opportunity?.data.situation.name}
                    </ListItem>
                    <ListItem label="STATUS">
                      {opportunity?.data.status.name}
                    </ListItem>
                    <ListItem label="PRÓXIMO CONTATO">
                      {dateTimeFormat(opportunity?.data.nextContact)}
                    </ListItem>
                    <ListItem label="PREVISÃO DE VENDAS">
                      {dateTimeFormat(opportunity?.data.salesForecast)}
                    </ListItem>
                    <ListItem label="VALIDADE DA PROPOSTA">
                      {dateFormat(opportunity?.data.proposalValidity)}
                    </ListItem>
                    <ListItem label="CONCEITO">
                      {opportunity?.data.concept.name}
                    </ListItem>
                    <ListItem label="DATA DA OPORTUNIDADE">
                      {dateFormat(opportunity?.data.createdAt)}
                    </ListItem>
                  </Col>
                </Row>
              </div>
            </Card>
          </TabPane>
          {/* <TabPane tab="Contatos" key="2">
            <Title>Contatos</Title>
            <Row gutter={[20, 20]}>
              {opportunity.data.customer.contacts.map((contact: any) => (
                <>
                  <Col xxl={6} xl={8} sm={12}>
                    <ContactCard
                      edit={() => {
                        /*empty
                      }}
                      remove={() => {
                        /*empty                      }}
                      key={contact.key}
                      state={contact}
                    />
                  </Col>
                </>
              ))}
            </Row>
          </TabPane>
        */}
        </Tabs>
        <Modal
          title="Editar Oportunidade"
          visible={isContactModalVisible}
          onOk={handleContactOk}
          onCancel={handleContactCancel}
          okText="Agendar"
          cancelText="Cancelar"
        >
          <DatePicker
            label="Próximo contato"
            format={'DD/MM/YYYY HH:mm:ss'}
            showTime
            onOk={onOk}
            placeholder="Selecione uma data"
          />

          <Select
            label="Conceito"
            allowClear
            loading={isConceptsLoading}
            value={conceptId || null}
            onSelect={(conceptId) => setConceptId(conceptId)}
          >
            {concepts?.data?.map((concept) => (
              <Option key={concept.id} value={concept.id}>
                {`${concept.name}`}
              </Option>
            ))}
          </Select>
        </Modal>
      </ContentBody>
    </div>
  )
}
